module.exports = __webpack_public_path__ + "static/media/business.5d558748.svg";